import Vue from 'vue'
import Router from 'vue-router'
// import {
// 	Message
// } from 'element-ui';
const includPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return includPush.call(this, location).catch(err => err)
}

Vue.use(Router);

const createRouter = () => new Router({
	mode: 'history',
	routes: [{ //官网根目录
			path: '/',
			redirect: 'webIndex',
			component: () => import('@/views/webIndex/index.vue'),
			children: [

				{ //首页
				path: '/webIndex',
				name: 'webIndex',
				component: () => import('@/views/webIndex/webIndex.vue'),
				meta: {
					title: ['网站首页']
				},
			}, { //选课中心
				path: '/announce',
				name: 'announce',
				redirect: '/announce/list',
				component: () => import('@/views/webIndex/announce.vue'),
				meta: {
					title: ['选课中心']
				},
				children: [{ //列表
					path: '/announce/list',
					name: 'list',
					component: () => import('@/views/webIndex/list.vue'),
					meta: {
						title: ['选课中心']
					}
				}]
			},

				{
					//登录
					path: '/login',
					name: 'login',
					component: () => import('@/views/webIndex/login.vue'),
					meta: {
						title: ['登录页']
					},
				},

				{
					//注册
					path: '/register',
					name: 'register',
					component: () => import('@/views/webIndex/register.vue'),
					meta: {
						title: ['注册页']
					},
				},
				{
					//忘记密码
					path: '/forgetpassword',
					name: 'forgetpassword',
					component: () => import('@/views/webIndex/forgetpassword.vue'),
					meta: {
						title: ['忘记密码']
					},
				},

				{ //详情
					path: '/detail/:id',
					name: 'detail',
					component: () => import('@/views/webIndex/detail.vue'),
					meta: {
						title: ['资讯', '详情']
					}
				},

				{ //行业动态
				path: '/dynamic',
				name: 'dynamic',
				redirect: '/dynamic/list',
				component: () => import('@/views/webIndex/dynamic.vue'),
				meta: {
					title: ['资讯']
				},
				children: [{ //列表
					path: '/dynamic/list',
					name: 'list',
					component: () => import('@/views/webIndex/list.vue'),
					meta: {
						title: ['资讯']
					}
				}, { //详情
					path: '/dynamic/detail/:id',
					name: 'detail',
					component: () => import('@/views/webIndex/detail.vue'),
					meta: {
						title: ['资讯', '详情']
					}
					}
				]
				},
				{
					//须知
					path: '/admissionNotice',
					name: 'admissionNotice',
					component: () => import('@/views/webIndex/admissionNotice.vue'),
				},

				{
					// 我的班级
					path: '/classdetail',
					name: 'classdetail',
					component: () => import('@/views/webIndex/classdetail.vue'),
					meta: {
						title: ['班级', '详情']
					}

				},

			]
		},

		{
			// 视频学习
			path: '/videoplay',
			name: 'videoplay',
			component: () => import('@/views/webIndex/videoplay.vue'),
			meta: {
				title: ['视频学习']
			},
		},

		{
			// 免费试听
			path: '/videoplayFree',
			name: 'videoplayFree',
			component: () => import('@/views/webIndex/videoplayFree.vue'),
			meta: {
				title: ['免费试听']
			},
		},

		{
			// 设置密码
			path: '/setpwd',
			name: 'setpwd',
			component: () => import('@/views/userIndex/setpwd.vue'),
			meta: {
				title: ['设置密码']
			},
		},

		{
			// 练习
			path: '/test',
			name: 'test',
			component: () => import('@/views/webIndex/test.vue'),

		},
		{
			// 练习
			path: '/testResult',
			name: 'testResult',
			component: () => import('@/views/webIndex/testResult.vue'),

		},

		{
			//练习
			path: '/practice',
			name: 'practice',
			component: () => import('@/views/webIndex/practice.vue'),

		},

		{
			// 登录后
			// 个人系统
			path: '/home',
			redirect: 'userinfo',
			component: () => import('@/views/userIndex/index.vue'),
			children: [{
				//个人信息
				path: '/userinfo',
				name: 'userinfo',
				component: () => import('@/views/userIndex/userinfo.vue'),
				meta: {
					uid:0,
					title: ['个人信息']
				}
			},
				{
					//练习
					path: '/practice_list',
					name: 'practice_list',
					component: () => import('@/views/webIndex/practice_list.vue'),

				},

				{
					//测试详情
					path: '/test_detail',
					name: 'test_detail',
					component: () => import('@/views/webIndex/test_detail.vue'),

				},
				{
					//专项练习
					path: '/specialQuesList',
					name: 'specialQuesList',
					component: () => import('@/views/webIndex/specialQuesList.vue'),

				},
				{
					// 我的班级
					path: '/myclass',
					name: 'myclass',
					component: () => import('@/views/userIndex/myclass.vue'),
					meta: {
						uid:1
					}
				},

				{
					// 考试记录
					path: '/test_record',
					name: 'test_record',
					component: () => import('@/views/webIndex/test_record.vue'),

				},

				{
					// 我的订单
					path: '/myorder',
					name: 'myorder',
					component: () => import('@/views/userIndex/myorder.vue'),
					meta: {
						uid:2
					}
				},
				{
					// 我的收藏
					path: '/mycollect',
					name: 'mycollect',
					component: () => import('@/views/userIndex/mycollect.vue'),
					meta: {}
				},
				{
					// 通知消息
					path: '/mynotice',
					name: 'mynotice',
					component: () => import('@/views/userIndex/mynotice.vue'),
					meta: {}
				},

				{
				// 修改手机号
				path: '/changephone',
				name: 'changephone',
				component: () => import('@/views/userIndex/changephone.vue'),
				meta: {}
			}, {
				// 修改密码
				path: '/changepassword',
				name: 'changepassword',
				component: () => import('@/views/userIndex/changepassword.vue'),
				meta: {
					title: ['修改密码']
				}
			}]
		}

	]
})

const router = createRouter();

// router.beforeEach((to, from, next) => {
// 	next()
// })

export default router;
